import * as React from "react";
import { cn } from "@/lib/utils";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
  current?: boolean;
}

export interface BreadcrumbV2Props {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
  className?: string;
}

export function BreadcrumbV2({
  items,
  separator = "/",
  className,
}: BreadcrumbV2Props) {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1.5 text-sm">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          const isCurrent = item.current || isLast;

          return (
            <li
              key={`${item.label}-${String(idx)}`}
              className="flex items-center gap-1.5"
            >
              {idx > 0 && (
                <span
                  className="text-[var(--v2-text-muted)] select-none"
                  aria-hidden="true"
                >
                  {separator}
                </span>
              )}

              {isCurrent ? (
                <span
                  aria-current="page"
                  className="font-medium text-[var(--v2-text-strong)]"
                >
                  {item.label}
                </span>
              ) : item.href ? (
                <a
                  href={item.href}
                  onClick={item.onClick}
                  className={cn(
                    "v2-focus-ring rounded-sm text-[var(--v2-text-muted)] transition hover:text-[var(--v2-accent)] hover:underline"
                  )}
                >
                  {item.label}
                </a>
              ) : (
                <button
                  type="button"
                  onClick={item.onClick}
                  className={cn(
                    "v2-focus-ring rounded-sm text-[var(--v2-text-muted)] transition hover:text-[var(--v2-accent)] hover:underline"
                  )}
                >
                  {item.label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
